export const UI_TEXT = {
	INITIAL_DISPLAY: "Unit Conversions",
	CALCULATOR_TITLE: "CX-3 FLIGHT COMPUTER",

	E6B_LABEL: "E6-B",
	DEFAULT_TIME: "22:007",
	BATTERY_LABEL: "BATT",
	NO_MENU_ITEMS: "No menu items available",
	INPUT_LABEL: "Input: ",
	MEMORY_LABEL: "M: ",

	ERROR_INVALID_NUMBER: "Error: Invalid number",
	ERROR_DIVISION_BY_ZERO: "Error: Division by zero",
	ERROR_INVALID_RESULT: "Error: Invalid result",

	DECIMAL_POINT: "0.",

	BUTTONS: {
		FLT: "FLT",
		PLAN: "PLAN",
		UP_ARROW: "▲",
		TIMER: "TIMER",
		CALC: "CALC",
		BACK: "BACK",
		STAR: "★",
		CIRCLE: "⚪",
		WEIGHT_BALANCE: "W/B",
		SET: "SET",
		MEMORY: "M",
		SET_UNIT: "SET\nUNIT",
		DOWN_ARROW: "▼",
		CONV_UNIT: "CONV\nUNIT",
		DIVIDE: "÷",
		CLEAR: "C",
		MULTIPLY: "×",
		BACKSPACE: "BKSP",
		MINUS: "−",
		COLON: ":",
		PLUS: "+",
		PLUS_MINUS: "±",
		DOT: ".",
		CHECKMARK: "✓",
		EQUALS: "=",
		ZERO: "0",
		ONE: "1",
		TWO: "2",
		THREE: "3",
		FOUR: "4",
		FIVE: "5",
		SIX: "6",
		SEVEN: "7",
		EIGHT: "8",
		NINE: "9",
	},
} as const;

export const BUTTON_ROW_NAMES = [
	"navigation",
	"function",
	"mode",
	"number1",
	"number2",
	"number3",
	"bottom",
] as const;
